import styled, { css } from 'styled-components';

interface CamProps {
  mobile: boolean;
}

interface CamSectionProps {
  photo: boolean;
}

export const CamSection = styled.section<CamSectionProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 320px;
  width: 400px;
  position: relative;
  border-radius: var(--radius-md);
  overflow: hidden;
  background: var(--stone-900);
  border: 1px solid var(--stone-900);

  @media (max-width: 600px) {
    width: 100%;
    height: ${p => (p.photo ? 'fit-content' : '280px')};
  }

  video {
    min-height: 300px;
    width: auto;
    background: var(--stone-900);
  }

  button {
    border: 0;
    background: var(--feedback-success);
    padding: 0.5rem;
    color: #fff;
    width: fit-content;
    border-radius: var(--radius-sm);
    align-self: center;
    box-shadow: var(--shadow-sm);
    transition: filter 0.2s;

    &:hover {
      filter: brightness(0.9);
      color: #fff;
    }
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const Crop = styled.div`
  margin-top: 0 !important;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  position: absolute;
  top: 0;
  justify-content: center;
`;

export const Actions = styled.div<CamProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  button {
    margin: 0 0.5rem;

    ${props =>
      props.mobile &&
      css`
        margin: 0.5rem;
      `}
  }
`;

export const UpFile = styled.label`
  cursor: pointer;
  position: relative;
  margin-left: 0.5rem;

  border: none;
  border-radius: var(--radius-md);
  font-weight: 700;
  font-family: var(--font-sans);
  color: var(--primary-foreground);
  background: var(--primary);
  font-size: 0.95rem;
  line-height: 1.5rem;
  height: 48px;
  padding: 0.5rem 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;

  &:hover {
    background: var(--primary-hover);
  }

  input {
    display: none;
  }
`;
